<template>
  <div
    v-if="showNotice"
    class="flex flex-col items-start gap-2 rounded-md border border-red-200 bg-red-100 px-3 py-3 text-red-600"
  >
    <div class="flex items-start gap-3 pl-1">
      <div
        class="flex flex-shrink-0 items-center justify-center rounded-full text-red-600"
      >
        <svg
          v-if="icon == 'flag'"
          class="relative -top-px inline-block h-5 w-5 flex-shrink-0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M3 2.25a.75.75 0 01.75.75v.54l1.838-.46a9.75 9.75 0 016.725.738l.108.054a8.25 8.25 0 005.58.652l3.109-.732a.75.75 0 01.917.81 47.784 47.784 0 00.005 10.337.75.75 0 01-.574.812l-3.114.733a9.75 9.75 0 01-6.594-.77l-.108-.054a8.25 8.25 0 00-5.69-.625l-2.202.55V21a.75.75 0 01-1.5 0V3A.75.75 0 013 2.25z"
            clip-rule="evenodd"
          />
        </svg>
        <svg
          v-if="icon == 'warning'"
          class="relative -top-px inline-block h-5 w-5 flex-shrink-0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <div class="text-xs text-red-600">
        <slot />
      </div>
    </div>
    <div
      v-if="showDismissFlag"
      class="w-full text-right"
    >
      <button
        class="cursor-pointer rounded-md border border-red-300 bg-red-200 px-2 py-1 text-xs text-red-600 hover:border-red-600 hover:bg-red-600 hover:text-white"
        @click="dismissFlag()"
      >
        Dismiss
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteNotice',
  props: {
    showDismissFlag: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'warning',
    },
  },
  data() {
    return {
      showNotice: true,
    };
  },
  methods: {
    dismissFlag() {
      this.showNotice = false;
    },
  },
};
</script>
